import styled from "styled-components";

export const LoginContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  height: "100vh",
  gap: "2rem",
  marginTop: "10rem",
});
